if ( typeof ProductPage !== 'function' ) {

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');

			this.pickupAvailabilityExtended = this.querySelector('pickup-availability-extended');

			// Gallery thumbnails
			if ( this.productSlider ) {

				const productGaleryThumbnails = this.querySelector('.product-gallery__thumbnails-holder');

				if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
						if ( i == 0 )  {
							elm.classList.add('active');
						}
						elm.addEventListener('click',e=>{
							if ( this.productSlider.sliderEnabled ) {
								this.productSlider.changeSlide(e.currentTarget.dataset.index);
							} else {
								window.scrollTo({
									top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).getBoundingClientRect().top + window.scrollY,
									behavior: 'smooth'
								});
								this.thumbnailNavigationHelper(e.currentTarget.dataset.index);
							}
							this._pauseAllMedia();
							this._playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`));
							productGaleryThumbnails.scrollTo({
								left: elm.offsetLeft - 50,
								behaviour: 'smooth'
							});
						});
					});

					this.productSlider.addEventListener('change', e=>{
						this.thumbnailNavigationHelper(e.target.index);
					});

				}

				this.productSlider.addEventListener('navigation', e=>{
					this._playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`));
				});
				this.productSlider.addEventListener('change', e=>{
					this._pauseAllMedia();
					if ( this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType == 'model' ) {
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId);
						}
						setTimeout(()=>{
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				// Parallax

				this.productSlider.addEventListener('ready', (e)=>{
					if ( this.firstProductGalleryIndex ) {
						this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
					}
				});

			}

			// Product variant event listener for theme specific logic

			this.productVariants = this.querySelector('product-variants');
			if ( this.productVariants ) {
				this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
				this.onVariantChangeHandler({target:this.productVariants});

				// refresh color
				this.querySelectorAll('.product-variant__item').forEach(elm => {
  elm.addEventListener('click', e => {
    const input = elm.querySelector('input');
    if (input) input.click();
  });
});


			}

			// show cart drawer when element is added to cart

			if ( ! document.body.classList.contains('template-cart') && KROWN.settings.cart_action == 'overlay' ) {

				let addToCartEnter = false;
				if ( this.querySelector('[data-js-product-add-to-cart]') ) {
					this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							addToCartEnter = true;

							$('#site-cart-sidebar').addClass('sidebar--opened');
						}
					});
				}

				if ( this.querySelector('[data-js-product-form]') ) {
					this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
						document.getElementById('site-cart-sidebar').show();
						if ( document.getElementById('cart-recommendations-sidebar') ) {
							document.getElementById('cart-recommendations-sidebar').generateRecommendations();
						}
						if ( addToCartEnter ) {
							setTimeout(()=>{
								document.querySelector('#site-cart-sidebar [data-js-close]').focus();
								$('#site-cart-sidebar').addClass('sidebar--opened');
							}, 200);
						}
					});
				}

			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			// hide buy now button if stock disabled

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart]');
			if ( addToCartButton ) {
				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				const buyObserver = new MutationObserver(()=>{
					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
			}

			// update secondary price if present

			this.priceCompact = this.querySelector('[data-js-product-price-compact');
			this.priceExtended = this.querySelector('[data-js-product-price-extended');

			if ( this.priceCompact ) {
				this.priceCompact.priceOriginal = this.priceCompact.querySelector('[data-js-product-price-original]');
				this.priceCompact.priceCompare = this.priceCompact.querySelector('[data-js-product-price-compare]');
				this.priceCompact.priceUnit = this.priceCompact.querySelector('[data-js-product-price-unit]');
				this.priceCompact.priceSale = this.priceCompact.querySelector('[data-js-product-price-sale]');
			}
			if ( this.priceExtended ) {
				this.priceExtended.priceOriginal = this.priceExtended.querySelector('[data-js-product-price-original]');
				this.priceExtended.priceCompare = this.priceExtended.querySelector('[data-js-product-price-compare]');
				this.priceExtended.priceSaving = this.priceExtended.querySelector('[data-js-product-price-saving]');
				this.priceExtended.priceUnit = this.priceExtended.querySelector('[data-js-product-price-unit]');
				this.priceExtended.priceSale = this.priceExtended.querySelector('[data-js-product-price-sale]');
			}

		}

		thumbnailNavigationHelper(index=0){
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
				if ( i == index ) {
					elm.classList.add('active');
				} else {
					elm.classList.remove('active');
				}
			});
		}

		onVariantChangeHandler(e){

			let variant = e.target.currentVariant;

			if ( variant ) {

				// Ensure the *actual* ATC form uses the selected variant
const atcBtn = this.querySelector('[data-js-product-add-to-cart]');
const atcForm = atcBtn?.closest('form');

if (atcForm) {
  const idInput = atcForm.querySelector('input[name="id"]');
  if (idInput) idInput.value = variant.id;
}


				var variantOption1 = variant.option1;
				var currentAlt = variantOption1.toLowerCase();

				function escapeHtml(text) {
				  var map = {
					'&': '&amp;',
					'<': '&lt;',
					'>': '&gt;',
					'"': '&quot;',
					"'": '&#039;'
				  };
				  return text.replace(/[&<>"']/g, function(m) { return map[m]; });
				}
				currentAlt = escapeHtml(currentAlt);
				currentAlt = currentAlt.replace(/ /g, '');

				const main_block = e.target.closest('product-page');

				if (currentAlt) {
					main_block.querySelectorAll('[thumbnail-alt]').forEach(div => {
						div.style.display = 'none';
					});

					const currentImageAlt = currentAlt;
					const thumbnailSelector = `[thumbnail-alt='${currentImageAlt}']`;

					document.querySelectorAll(thumbnailSelector).forEach(div => {
						div.style.display = 'block';
					});

				} else {
					main_block.querySelectorAll('[thumbnail-alt]').forEach(div => {
						div.style.display = 'block';
					});
				}

				var productGalleryItems = document.querySelectorAll('.gallery_images_filter');
				var firstVisibleProductGalleryItem = Array.from(productGalleryItems).find(function(item) {
				  return item.style.display !== 'none';
				});

				var targetDiv = document.querySelector('.static-left-gallery-tint');

				if (firstVisibleProductGalleryItem && targetDiv) {
				  targetDiv.appendChild(firstVisibleProductGalleryItem);
				}

				// image handling

				if ( variant.featured_media != null ) {
					let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
					if ( variantImg ) {
						if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
							if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
								this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
							} else {
								this.firstProductGalleryIndex = variantImg.dataset.index;
							}
						} else {
							window.scrollTo({
								top: variantImg.getBoundingClientRect().top + window.scrollY,
								behavior: 'smooth'
							});
						}
					}
				}

				// refresh pickup availability widgets

				if ( this.pickupAvailabilityExtended && this.pickupAvailabilityExtended.classList.contains('active') ) {
					this.querySelector('pickup-availability-extended').fetchAvailability(variant.id);
				}

			}

			// update prices (overwrites the framework)

			if ( this.priceCompact ) {
				if ( !variant ) {
					if ( ! ( this.productVariants.variantRequired && this.productVariants.noVariantSelectedYet ) ) {
						this.priceCompact.classList.add('hide');
						this.priceCompact.priceOriginal.innerHTML = '';
						this.priceCompact.priceCompare.innerHTML = '';
						this.priceCompact.priceUnit.innerHTML = '';
						this.priceCompact.priceSale.innerHTML = '';
					}
				} else {
					this.priceCompact.classList.remove('hide');
					this.priceCompact.priceOriginal.innerHTML = this.productVariants._formatMoney(variant.price, KROWN.settings.shop_money_format);
					if ( variant.compare_at_price > variant.price ) {
						this.priceCompact.priceCompare.innerHTML = this.productVariants._formatMoney(variant.compare_at_price, KROWN.settings.shop_money_format);
						this.priceCompact.priceSale.innerHTML = `-${Math.round(Math.abs((variant.price * 100 / variant.compare_at_price) - 100))}%`;
					} else {
						this.priceCompact.priceCompare.innerHTML = '';
						this.priceCompact.priceSale.innerHTML = '';
					}

					if ( variant.unit_price_measurement ) {
						this.priceCompact.priceUnit.innerHTML = `
							${this.productVariants._formatMoney(variant.unit_price, KROWN.settings.shop_money_format)} / 
							${( variant.unit_price_measurement.reference_value != 1 ? variant.unit_price_measurement.reference_value + ' ' : '' )}
							${variant.unit_price_measurement.reference_unit}
						`;
					} else {
						if (this.priceCompact && this.priceCompact.priceUnit) {
							this.priceCompact.priceUnit.innerHTML = '';
						} 
					}
				}
			}

			if ( this.priceExtended ) {
				if ( !variant ) {
					this.priceExtended.classList.add('hide');
					this.priceExtended.priceOriginal.innerHTML = '';
					this.priceExtended.priceCompare.innerHTML = '';
					this.priceExtended.priceUnit.innerHTML = '';
					this.priceExtended.priceSaving.innerHTML = '';
				} else {
					this.priceExtended.classList.remove('hide');
					this.priceExtended.priceOriginal.innerHTML = this.productVariants._formatMoney(variant.price, KROWN.settings.shop_money_format);
					if ( variant.compare_at_price > variant.price ) {
						this.priceExtended.priceCompare.innerHTML = `<span>${this.productVariants._formatMoney(variant.compare_at_price, KROWN.settings.shop_money_format)}</span>`;
						this.priceExtended.priceSaving.innerHTML = `<span>${KROWN.settings.locales.product_compare_price.replace('$SAVE_PRICE', this.productVariants._formatMoney(variant.compare_at_price - variant.price, KROWN.settings.shop_money_format))}</span>`;
					} else {
						this.priceExtended.priceCompare.innerHTML = '';
						this.priceExtended.priceSaving.innerHTML = '';
					}

					if ( variant.unit_price_measurement ) {
						this.priceExtended.priceUnit.innerHTML = `
							${this.productVariants._formatMoney(variant.unit_price, KROWN.settings.shop_money_format)} / 
							${( variant.unit_price_measurement.reference_value != 1 ? variant.unit_price_measurement.reference_value + ' ' : '' )}
							${variant.unit_price_measurement.reference_unit}
						`;
					} else {
						this.priceExtended.priceUnit.innerHTML = '';
					}
				}
			}

		}

		_pauseAllMedia(){

			document.querySelectorAll('.product-gallery .js-youtube').forEach(video => {
				video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
			});
			document.querySelectorAll('.product-gallery .js-vimeo').forEach(video => {
				video.contentWindow.postMessage('{"method":"pause"}', '*');
			});
			document.querySelectorAll('.product-gallery video').forEach(video => video.pause());
			document.querySelectorAll('.product-gallery product-model').forEach(model => {
				if ( model.modelViewerUI ) {
					model.modelViewerUI.pause();
				}
			});
		}
		
		_playMedia(media){
			switch ( media.dataset.productMediaType ) {
				case 'video':
					if ( media.querySelector('video') ) {
						media.querySelector('video').play();
					}
					break;
				case 'external_video-youtube':
					if ( media.querySelector('.js-youtube') ) {
						media.querySelector('.js-youtube').contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
					}
					break;
				case 'external_video-vimeo':
					if ( media.querySelector('.js-vimeo') ) {
						media.querySelector('.js-vimeo').contentWindow.postMessage('{"method":"play"}', '*');
					}
					break;
			}
		}

	}

	if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}
// ===================================
// DESKTOP THUMBNAILS → MAIN MEDIA (image / video)
// ===================================
document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth < 992) return;

  const mainContainer = document.querySelector('.product-main-image');
  const thumbs = document.querySelectorAll('.product-thumbnails .product-thumbnail');

  if (!mainContainer || !thumbs.length) return;

  let currentIndex = 0;

  const renderFromThumb = (thumb, index) => {
    const mediaType = thumb.dataset.mediaType || 'image';
    const img = thumb.querySelector('img');
    const large = thumb.dataset.large || (img ? img.src : '');

    // Active state
    thumbs.forEach(t => t.classList.remove('is-active'));
    thumb.classList.add('is-active');

    currentIndex = index;
    window.currentDesktopImageIndex = index;

    // ---- VIDEO (Shopify-hosted) ----
    if (mediaType === 'video') {
      const videoSrc = thumb.dataset.videoSrc;
if (!videoSrc || videoSrc.includes("VideoDrop")) {
  console.error("❌ Invalid video URL in thumbnail dataset", thumb);
  return;
}

      const poster = thumb.dataset.videoPoster || large;
      if (!videoSrc) return;

      const posterAttr = poster ? ` poster="${poster}"` : '';

      mainContainer.innerHTML = `
  <div class="product-main-video-wrapper" style="position:relative">
    <div class="mobile-video-overlay">
      <svg viewBox="0 0 24 24">
        <polygon points="9,7 9,17 17,12"></polygon>
      </svg>
    </div>
    <video class="product-main-video"
           muted
           playsinline
           loop
           preload="metadata"
           ${posterAttr}>
      <source src="${videoSrc}" type="video/mp4">
    </video>
  </div>
`;

const vid = mainContainer.querySelector('video');
const overlay = mainContainer.querySelector('.mobile-video-overlay');

// Desktop autoplay remains active
if (window.innerWidth >= 992) {
  vid.setAttribute("autoplay", "true");
  vid.play().catch(()=>{});
}

// Mobile tap-to-play
if (window.innerWidth < 992) {
  overlay.addEventListener('click', () => {
    overlay.classList.add("hidden");
    vid.setAttribute("controls", "true");
    vid.play();
  });
}


      return;
    }

    // ---- EXTERNAL VIDEO (YouTube / Vimeo) ----
    if (mediaType === 'external_video') {
      const host = thumb.dataset.externalHost;
      const externalId = thumb.dataset.externalId;
      let src = '';

      if (host === 'youtube') {
        src = `https://www.youtube.com/embed/${externalId}?autoplay=0&loop=0`;
      } else if (host === 'vimeo') {
        src = `https://player.vimeo.com/video/${externalId}`;
      }

      if (!src) return;

      mainContainer.innerHTML = `
        <div class="product-main-video-wrapper">
          <iframe
            class="product-main-iframe"
            src="${src}"
            title="Product video"
            frameborder="0"
            allowfullscreen
          ></iframe>
        </div>
      `;
      return;
    }

    // ---- IMAGE (default) ----
    if (!large) return;

    mainContainer.innerHTML = `
      <div class="pdp-hover-zoom" data-hover-zoom style="--zoom-scale: 2;">
        <figure class="product-media-item product-media-item--image">
          <img src="${large}" alt="">
        </figure>
      </div>
    `;
};

  // init from first thumb
  renderFromThumb(thumbs[0], 0);

  thumbs.forEach((thumb, index) => {
    thumb.addEventListener('mouseenter', () => renderFromThumb(thumb, index));
    thumb.addEventListener('click', (e) => {
      e.preventDefault();
      renderFromThumb(thumb, index);
    });
  });
});



// ===================================
// PDP HOVER ZOOM (Zalando-like) — Desktop only
// - Hover zoom scale: 2x
// - Keeps pointer as magnifier (zoom-in)
// ===================================
document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth < 992) return; // desktop only

  // Avoid binding on touch-capable devices (trackpads are fine)
  const isTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints && navigator.maxTouchPoints > 0);
  if (isTouch) return;

  const attachHoverZoom = (wrapper) => {
    if (!wrapper || wrapper.__hoverZoomBound) return;
    wrapper.__hoverZoomBound = true;

    const updateVars = (e) => {
      const rect = wrapper.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      wrapper.style.setProperty('--zoom-x', `${x}%`);
      wrapper.style.setProperty('--zoom-y', `${y}%`);
    };

    wrapper.addEventListener('mouseenter', () => wrapper.classList.add('is-zoomed'));
    wrapper.addEventListener('mousemove', updateVars, { passive: true });
    wrapper.addEventListener('mouseleave', () => {
      wrapper.classList.remove('is-zoomed');
      wrapper.style.removeProperty('--zoom-x');
      wrapper.style.removeProperty('--zoom-y');
    });
  };

  // Bind existing
  document.querySelectorAll('[data-hover-zoom]').forEach(attachHoverZoom);

  // Re-bind when main image is replaced by thumbnail hover/click
  const main = document.querySelector('.product-main-image');
  if (!main) return;

  const mo = new MutationObserver(() => {
    main.querySelectorAll('[data-hover-zoom]').forEach(attachHoverZoom);
  });
  mo.observe(main, { childList: true, subtree: true });
});

// ===================================
// MOBILE HORIZONTAL GALLERY COUNTER
// ===================================
document.addEventListener('DOMContentLoaded', () => {
  const mobileGallery = document.querySelector('.product-mobile-gallery');
  if (!mobileGallery) return;

  const scrollContainer =
    mobileGallery.querySelector('.product-mobile-gallery__track') || mobileGallery;

  const items = mobileGallery.querySelectorAll('.product-mobile-gallery__item');
  const currentEl = mobileGallery.querySelector('[data-mobile-counter-current]');
  const totalEl = mobileGallery.querySelector('[data-mobile-counter-total]');

  if (!items.length || !currentEl || !totalEl) return;

  totalEl.textContent = items.length;

  const updateCounter = () => {
    let closestIndex = 0;
    let minDelta = Infinity;

    items.forEach((item, index) => {
      const rect = item.getBoundingClientRect();
      const delta = Math.abs(rect.left);
      if (delta < minDelta) {
        minDelta = delta;
        closestIndex = index;
      }
    });

    currentEl.textContent = closestIndex + 1;
  };

  updateCounter();
  scrollContainer.addEventListener('scroll', updateCounter, { passive: true });
});


// ===================================
// DESKTOP ZOOM MODAL
// - Open from PDP main image click (NOT zoomed)
// - Single click inside modal toggles zoom 1x <-> 4x
// - Dragging only when zoomed
// ===================================
document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth < 992) return; // desktop only

  const modal = document.querySelector('.desktop-zoom-modal');
  if (!modal) return;

  const zoomImg  = modal.querySelector('.desktop-zoom-image');
  const overlay  = modal.querySelector('.desktop-zoom-overlay');
  const btnClose = modal.querySelector('.desktop-zoom-close');
  const btnPrev  = modal.querySelector('.desktop-zoom-prev');
  const btnNext  = modal.querySelector('.desktop-zoom-next');
  const content  = modal.querySelector('.desktop-zoom-content') || modal;

  const thumbs = document.querySelectorAll('.product-thumbnails .product-thumbnail');
  if (!zoomImg || !thumbs.length) return;

  let currentIndex = typeof window.currentDesktopImageIndex === 'number' ? window.currentDesktopImageIndex : 0;

  // transform state
  const ZOOM_MAX = 2.5;
  let scale = 1;
  let startX = 0, startY = 0, currentX = 0, currentY = 0;
  let dragging = false;

  const setZoomedFlag = (zoomed) => {
    modal.dataset.zoomed = zoomed ? 'true' : 'false';
    // CSS handles cursor = zoom-in when false; when zoomed we use grab/grabbing
    zoomImg.style.cursor = zoomed ? 'grab' : 'zoom-in';
  };

  const applyTransform = () => {
    zoomImg.style.transform = `translate(${currentX}px, ${currentY}px) scale(${scale})`;
  };

  const resetTransform = () => {
    scale = 1;
    currentX = 0;
    currentY = 0;
    zoomImg.style.transformOrigin = '50% 50%';
    applyTransform();
    setZoomedFlag(false);
  };

  const setImageForIndex = (index) => {
    const thumb = thumbs[index];
    if (!thumb) return;
    const img = thumb.querySelector('img');
    const src = thumb.dataset.large || img?.src;
    if (!src) return;

    zoomImg.src = src;
    resetTransform(); // ALWAYS start unzoomed
  };

  const openModal = (index) => {
    currentIndex = index;
    modal.classList.add('active');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    // ensure unzoomed on open, even on smaller desktops
    modal.dataset.zoomed = 'false';
    setImageForIndex(currentIndex);
  };

  const closeModal = () => {
    modal.classList.remove('active');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    resetTransform();
  };

  // Open modal (delegated, survives re-renders)
  const mainImageContainer = document.querySelector('.product-main-image');
  if (mainImageContainer) {
    mainImageContainer.addEventListener('click', (e) => {
      const img = e.target.closest('img');
      if (!img) return;

      // If a hover-zoom wrapper exists, force it back to neutral before opening modal
      const hoverWrapper = img.closest('[data-hover-zoom]');
      if (hoverWrapper) {
        hoverWrapper.classList.remove('is-zoomed');
        hoverWrapper.style.removeProperty('--zoom-x');
        hoverWrapper.style.removeProperty('--zoom-y');
      }

      const startIndex = typeof window.currentDesktopImageIndex === 'number'
        ? window.currentDesktopImageIndex
        : 0;

      openModal(startIndex);
    });
  }

  // Close
  btnClose && btnClose.addEventListener('click', closeModal);
  overlay && overlay.addEventListener('click', closeModal);
  document.addEventListener('keydown', (e) => {
    if (!modal.classList.contains('active')) return;
    if (e.key === 'Escape') closeModal();
    if (e.key === 'ArrowLeft') {
      currentIndex = (currentIndex - 1 + thumbs.length) % thumbs.length;
      setImageForIndex(currentIndex);
    }
    if (e.key === 'ArrowRight') {
      currentIndex = (currentIndex + 1) % thumbs.length;
      setImageForIndex(currentIndex);
    }
  });

  // Prev/next
  btnPrev && btnPrev.addEventListener('click', (e) => {
    e.stopPropagation();
    currentIndex = (currentIndex - 1 + thumbs.length) % thumbs.length;
    setImageForIndex(currentIndex);
  });
  btnNext && btnNext.addEventListener('click', (e) => {
    e.stopPropagation();
    currentIndex = (currentIndex + 1) % thumbs.length;
    setImageForIndex(currentIndex);
  });

  // Single click to toggle zoom (1x <-> 4x)
  // - Click on UI controls shouldn't toggle
  const isControlClick = (target) => {
    return !!target.closest('.desktop-zoom-close, .desktop-zoom-prev, .desktop-zoom-next');
  };

  content.addEventListener('click', (e) => {
    if (!modal.classList.contains('active')) return;
    if (isControlClick(e.target)) return;

    if (scale <= 1) {
      scale = ZOOM_MAX;
      currentX = 0;
      currentY = 0;
      applyTransform();
      setZoomedFlag(true);
    } else {
      resetTransform();
    }
  });

  // Drag to move when zoomed
  content.addEventListener('mousedown', (e) => {
    if (!modal.classList.contains('active')) return;
    if (scale <= 1) return;

    dragging = true;
    startX = e.clientX - currentX;
    startY = e.clientY - currentY;
    zoomImg.style.cursor = 'grabbing';
  });

  content.addEventListener('mousemove', (e) => {
    if (!dragging) return;

    const containerRect = content.getBoundingClientRect();
    const imgRect = zoomImg.getBoundingClientRect();

    let newX = e.clientX - startX;
    let newY = e.clientY - startY;

    const maxX = Math.max(0, (imgRect.width - containerRect.width) / 2);
    const maxY = Math.max(0, (imgRect.height - containerRect.height) / 2);

    currentX = Math.min(Math.max(newX, -maxX), maxX);
    currentY = Math.min(Math.max(newY, -maxY), maxY);

    applyTransform();
  });

  ['mouseup', 'mouseleave'].forEach((ev) => {
    content.addEventListener(ev, () => {
      dragging = false;
      zoomImg.style.cursor = (scale > 1) ? 'grab' : 'zoom-in';
    });
  });
});


document.addEventListener('click', function(e) {

  const video = e.target.closest('.product-media-item--video')?.querySelector('video');

  if (video) {
    video.play().catch(()=>{});
  }

});


document.addEventListener("DOMContentLoaded", () => {
  const video = document.querySelector(".product-main-video");
  const overlay = document.querySelector(".mobile-video-overlay");

  if (video && overlay) {
    video.addEventListener("play", () => {
      overlay.style.opacity = "0";
      overlay.style.pointerEvents = "none";
    });

    video.addEventListener("pause", () => {
      overlay.style.opacity = "1";
    });
  }
});